// import React, { useState, useEffect } from 'react';
// import { functions } from '../firebaseConfig'; // Import your Firebase config
// import { httpsCallable } from 'firebase/functions';
// import './PostcodeSearch-VIP.scss';

// const acceptedPostcodes = [
//   'DH1', 'DH2', 'DH3', 'DH4', 'DH5', 'DH6', 'DH7', 'DH8', 'DH9',
//   'SR2', 'SR3', 'SR4', 'SR5',
//   'NE5', 'NE6', 'NE8', 'NE9', 'NE10', 'NE11',
//   'NE15', 'NE16', 'NE17', 'NE21', 'NE25', 'NE26', 'NE27', 'NE28', 'NE29', 'NE30',
//   'NE37', 'NE38', 'NE39', 'NE40', 'NE41', 'NE42'
// ];

// const PostcodeSearch = ({
//   onPostcodeChange,
//   onSelectAddress,
//   postcode,
//   errors, // Receive errors prop for styling
// }) => {
//   const [addresses, setAddresses] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [dropdownEnabled, setDropdownEnabled] = useState(false);
//   const [selectedAddress, setSelectedAddress] = useState(''); // Store selected address
//   const [outsideArea, setOutsideArea] = useState(false); // Track if postcode is outside area

//   const validatePostcode = (postcode) => {
//     const postcodeRegex = /^[A-Z]{1,2}\d{1,2}[A-Z]?\s?\d[A-Z]{2}$/i;
//     return postcodeRegex.test(postcode.trim());
//   };

//   const isPostcodeAccepted = (postcode) => {
//     const formattedPostcode = postcode.replace(/\s+/g, '').toUpperCase(); // Remove spaces and ensure uppercase
//     const areaCode = formattedPostcode.slice(0, formattedPostcode.length - 3); // Extract area code (first part)
//     return acceptedPostcodes.includes(areaCode);
//   };
  

//   useEffect(() => {
//     if (validatePostcode(postcode)) {
//       if (isPostcodeAccepted(postcode)) {
//         setOutsideArea(false);
//         fetchAddresses(postcode);
//       } else {
//         setOutsideArea(true);
//         setDropdownEnabled(false);
//         setAddresses([]);
//       }
//     } else {
//       setOutsideArea(false);
//       setDropdownEnabled(false);
//       setAddresses([]);
//     }
//   }, [postcode]);

//   const handlePostcodeInputChange = (e) => {
//     const value = e.target.value.toUpperCase();
//     onPostcodeChange(value);
//     setSelectedAddress(''); // Reset selected address when postcode changes
//   };

//   // Using Firebase Cloud Functions to fetch addresses
//   const fetchAddresses = async (postcode) => {
//     setLoading(true);
//     try {
//       const fetchAddressFunction = httpsCallable(functions, 'fetchAddresses'); // Firebase function
//       const result = await fetchAddressFunction({ postcode });
//       console.log('Addresses:', result);
//       setAddresses(result.data.addresses || []);
//       setDropdownEnabled(true);
//     } catch (err) {
//       console.error('Failed to fetch addresses:', err);
//       setDropdownEnabled(false);
//       setAddresses([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleAddressSelect = (e) => {
//     const value = e.target.value;
//     if (value) {
//       const address = JSON.parse(value);
//       setSelectedAddress(value); // Set the selected value as the full JSON string
//       onSelectAddress(address.DPA.ADDRESS); // Pass only the address text to parent
//     } else {
//       onSelectAddress(''); // Clear address if no selection
//       setSelectedAddress('');
//     }
//   };

//   const capitalizeAddress = (address) => {
//     // Remove everything after the last comma (including the comma)
//     const trimmedAddress = address.substring(0, address.lastIndexOf(',')).trim();
  
//     // Capitalize the first letter of each word
//     return trimmedAddress
//       .toLowerCase()
//       .replace(/\b\w/g, (char) => char.toUpperCase());
//   };
  
  

//   return (
//     <div className="postcode-search-component">
//       {/* Postcode Input */}
//       <input
//         type="text"
//         placeholder="Enter postcode"
//         value={postcode}
//         onChange={handlePostcodeInputChange}
//         className={`postcode-search-input ${
//           errors && errors.postcode ? 'error-border' : ''
//         }`}
//       />

//       {/* Outside Area Message */}
//       {outsideArea && (
//         <p className="postcode-outside-area-message" style={{ marginTop:'0px', color: 'red' }}>
//           * This postcode is outside our area
//         </p>
//       )}

//       {/* Loading Indicator */}
//       {loading && (
//         <p className="postcode-search-loading">Loading addresses...</p>
//       )}



// <select
//   onChange={handleAddressSelect}
//   disabled={!dropdownEnabled}
//   className={`postcode-search-dropdown ${
//     errors.address ? 'error-border' : ''
//   }`}
//   value={selectedAddress} // Set to full JSON string of selected address
// >
//   <option value="">Select an address</option>
//   {addresses.map((address, index) => (
//     <option key={index} value={JSON.stringify(address)}>
//       {capitalizeAddress(address.DPA.ADDRESS)}
//     </option>
//   ))}
// </select>



//     </div>
//   );
// };

// export default PostcodeSearch;

import React, { useState, useEffect } from 'react';
import { functions } from '../firebaseConfig'; // Import your Firebase config
import { httpsCallable } from 'firebase/functions';
import './PostcodeSearch-VIP.scss';

const areaToPostcodes = {
  "Chester-Le-Street": ["DH2", "DH3", "DH9"],
  "Consett": ["DH8"],
  "Crawcrook": ["NE40", "NE41"],
  "Durham": ["DH1", "DH6", "DH7"],
  "Houghton-Le-Spring": ["DH4", "DH5"],
  "Low Fell": ["NE8", "NE9", "NE10"],
  "Rowlands Gill": ["NE16", "NE17", "NE39"],
  "Sunderland": ["SR2", "SR3", "SR4", "SR5", "SR6"],
  "Washington": ["NE37", "NE38"],
  "Wallsend": ["NE6", "NE28"],
  "West Denton": ["NE5", "NE15"],
  "Whickham": ["NE11", "NE16", "NE21"],
  "Whitley Bay": ["NE25", "NE26", "NE27", "NE28", "NE29", "NE30"],
};

// Generate postcode to area mapping
const postcodeToArea = Object.entries(areaToPostcodes).reduce((acc, [area, postcodes]) => {
  postcodes.forEach((postcode) => {
    acc[postcode] = area;
  });
  return acc;
}, {});

const PostcodeSearch = ({
  onPostcodeChange,
  onSelectAddress,
  postcode,
  errors, // Receive errors prop for styling
  setArea, // Add callback to set the area
}) => {
  const [addresses, setAddresses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dropdownEnabled, setDropdownEnabled] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(''); // Store selected address
  const [outsideArea, setOutsideArea] = useState(false); // Track if postcode is outside area

  const validatePostcode = (postcode) => {
    const postcodeRegex = /^[A-Z]{1,2}\d{1,2}[A-Z]?\s?\d[A-Z]{2}$/i;
    return postcodeRegex.test(postcode.trim());
  };

  const isPostcodeAccepted = (postcode) => {
    const formattedPostcode = postcode.replace(/\s+/g, '').toUpperCase(); // Remove spaces and ensure uppercase
    return Object.keys(postcodeToArea).some((key) => formattedPostcode.startsWith(key)); // Check if any area matches
  };

  const getAreaFromPostcode = (postcode) => {
    const formattedPostcode = postcode.replace(/\s+/g, '').toUpperCase(); // Remove spaces and ensure uppercase
    return Object.entries(areaToPostcodes).find(([area, postcodes]) =>
      postcodes.some((pc) => formattedPostcode.includes(pc))
    )?.[0]; // Return area name if any part matches, else null
  };

  useEffect(() => {
    if (validatePostcode(postcode)) {
      if (isPostcodeAccepted(postcode)) {
        const area = getAreaFromPostcode(postcode);
        setOutsideArea(false);
        fetchAddresses(postcode);
        if (area) {
          setArea(area); // Pass the area back to the parent
        }
      } else {
        setOutsideArea(true);
        setDropdownEnabled(false);
        setAddresses([]);
        setArea(null); // Clear area if postcode is invalid
      }
    } else {
      setOutsideArea(false);
      setDropdownEnabled(false);
      setAddresses([]);
      setArea(null); // Clear area if postcode is invalid
    }
  }, [postcode]);

  const handlePostcodeInputChange = (e) => {
    const value = e.target.value.toUpperCase();
    onPostcodeChange(value);
    setSelectedAddress(''); // Reset selected address when postcode changes
  };

  // Using Firebase Cloud Functions to fetch addresses
  const fetchAddresses = async (postcode) => {
    setLoading(true);
    try {
      const fetchAddressFunction = httpsCallable(functions, 'fetchAddresses'); // Firebase function
      const result = await fetchAddressFunction({ postcode });
      console.log('Addresses:', result);
      setAddresses(result.data.addresses || []);
      setDropdownEnabled(true);
    } catch (err) {
      console.error('Failed to fetch addresses:', err);
      setDropdownEnabled(false);
      setAddresses([]);
    } finally {
      setLoading(false);
    }
  };

  const handleAddressSelect = (e) => {
    const value = e.target.value;
    if (value) {
      const address = JSON.parse(value);
      setSelectedAddress(value); // Set the selected value as the full JSON string
      onSelectAddress(address.DPA.ADDRESS); // Pass only the address text to parent
    } else {
      onSelectAddress(''); // Clear address if no selection
      setSelectedAddress('');
    }
  };

  const capitalizeAddress = (address) => {
    // Remove everything after the last comma (including the comma)
    const trimmedAddress = address.substring(0, address.lastIndexOf(',')).trim();
  
    // Capitalize the first letter of each word
    return trimmedAddress
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };
  
  return (
    <div className="postcode-search-component">
      {/* Postcode Input */}
      <input
        type="text"
        placeholder="Enter postcode"
        value={postcode}
        onChange={handlePostcodeInputChange}
        className={`postcode-search-input ${
          errors && errors.postcode ? 'error-border' : ''
        }`}
      />

      {/* Outside Area Message */}
      {outsideArea && (
        <p className="postcode-outside-area-message" style={{ marginTop:'0px', color: 'red' }}>
          * This postcode is outside our area
        </p>
      )}

      {/* Loading Indicator */}
      {loading && (
        <p className="postcode-search-loading">Loading addresses...</p>
      )}

      {/* Dropdown for Addresses */}
      <select
        onChange={handleAddressSelect}
        disabled={!dropdownEnabled}
        className={`postcode-search-dropdown ${
          errors.address ? 'error-border' : ''
        }`}
        value={selectedAddress} // Set to full JSON string of selected address
      >
        <option value="">Select an address</option>
        {addresses.map((address, index) => (
          <option key={index} value={JSON.stringify(address)}>
            {capitalizeAddress(address.DPA.ADDRESS)}
          </option>
        ))}
      </select>
    </div>
  );
};

export default PostcodeSearch;
